export enum AnimationsEnum {
  fade = 'fade',
  slide = 'slide'
}
